/**
 * Quantity with at most 3 decimals, without needless zeros: 12.5000 -> "12.5", 12.3400 -> "12.34",
 * 12.34567 -> "12.346", 7.0 -> "7". The dot is the decimal separator (as in the examples from the requirements).
 */
export function formatQty(value) {
  const n = typeof value === "number" ? value : parseFloat(String(value ?? "").replace(",", "."));
  if (!Number.isFinite(n)) return "";
  const r = Math.round(n * 1000) / 1000;
  return String(Object.is(r, -0) ? 0 : r);
}

/**
 * Waiters of a single table: "A, B, C". Accepts an array or comma-separated text, removes empty entries and duplicates,
 * so it works both when the server returns one waiter and when it returns several (the number is not limited).
 */
export function formatWaiters(value) {
  const list = Array.isArray(value) ? value : String(value ?? "").split(",");
  const seen = new Set();
  const out = [];
  list.forEach((w) => {
    const name = String(w ?? "").trim();
    if (name && !seen.has(name.toLowerCase())) {
      seen.add(name.toLowerCase());
      out.push(name);
    }
  });
  return out.join(", ");
}
